// src/pages/in-kind/DonateInput.js
import InKindInputForm from "../../components/InKindInputForm";

function DonateInput() {
  return <InKindInputForm contributionType="donate" />;
}

export default DonateInput;